import { EmployeeDTO } from '@iota/iota-management-portal-v4-client';
import { createAction, props } from '@ngrx/store';

export enum EmployeeActionTypes {
    LoadAllEmployeesByCompany = '[Employee] Load All Employees By Company',

    LoadEmployeesSuccess = '[Employee] Load Employees Success',
    LoadEmployeesFailure = '[Employee] Load Employees Failure'
}

export const LoadAllEmployeesByCompany = createAction(EmployeeActionTypes.LoadAllEmployeesByCompany, props<{ companyId: string }>());

export const LoadEmployeesSuccess = createAction(EmployeeActionTypes.LoadEmployeesSuccess, props<{ employees: EmployeeDTO[] }>());
export const LoadEmployeesFailure = createAction(EmployeeActionTypes.LoadEmployeesFailure, props<{ error: any }>());
